"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
function BoldArrow({ size = 40, color = "primary", bold = 5 }) {
    return ((0, jsx_runtime_1.jsx)("div", { style: {
            color: color
        }, className: `text-${color}`, children: (0, jsx_runtime_1.jsx)("span", { style: {
                fontSize: size,
                WebkitTextStrokeWidth: bold,
                WebkitTextStrokeColor: "inherit",
            }, children: "\u3031" }) }));
}
exports.default = BoldArrow;
